import type { Track } from "./store/music-player-store";

/**
 * Default playlist configuration
 * Add your MP3 files to the public/audio/ directory and reference them here
 */
export const defaultPlaylist: Track[] = [
  createTrack("aspire", "Aspire", "Aspire.mp3"),
  createTrack("eternal", "Eternal", "Eternal.mp3"),
  createTrack("march-on", "March On", "March On.mp3"),
  createTrack("mist", "Mist", "Mist.mp3"),
  createTrack("resonate", "Resonate", "Resonate.mp3"),
  createTrack("slip", "Slip", "Slip.mp3"),
  createTrack("trust", "Trust", "Trust.mp3"),
  createTrack("vampiric", "Vampiric", "Vampiric.mp3"),
];

/**
 * Helper function to create a track object
 */
export function createTrack(
  id: string,
  title: string,
  filename: string,
  basePath: string = "/audio"
): Track {
  return {
    id,
    title,
    filename,
    path: `${basePath}/${filename}`,
  };
}

/**
 * Load playlist from a list of filenames
 * Useful for dynamically loading tracks
 */
export function createPlaylistFromFilenames(
  filenames: string[],
  basePath: string = "/audio"
): Track[] {
  return filenames.map((filename, index) => {
    const title = filename
      .replace(/\.mp3$/i, "")
      .replace(/[-_]/g, " ")
      .replace(/\b\w/g, (l) => l.toUpperCase());
    
    return createTrack(`track-${index}`, title, filename, basePath);
  });
}

